import { z } from 'zod';
import { PortalConsumerInSchema, PortalDeactivatedCodeEnumSchema, PortalEntityTypeSchema, StagedPortalConsumerInSchema, } from '../../base/portal.js';
import { PortalZoneSchema } from '../../base/zones.js';
export const DeactivatePortalRequestBodySchema = z.object({
    deactivatedCode: PortalDeactivatedCodeEnumSchema,
    deactivatedReason: z.string().optional(),
    externalUserId: z.string(),
    entityId: z.string(),
    entityType: PortalEntityTypeSchema,
    requestActor: z.string(),
    zone: PortalZoneSchema,
});
export const DeactivatePortalRequestSchema = DeactivatePortalRequestBodySchema;
export const DeactivatePortalResponseSchema = z.object({
    portal: PortalConsumerInSchema.or(StagedPortalConsumerInSchema).or(z.null()),
});
export const DeactivatePortalApiSchema = {
    body: DeactivatePortalRequestBodySchema,
    response: DeactivatePortalResponseSchema,
};
